import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { useMemo } from "react";
import { studentsApi } from "../../../services/students/studentsApi";

const transformData = (report: any) => {
  // Create a map to hold the aggregated data
  const aggregatedData = new Map();

  report.forEach((item: any) => {
    const key = `${item.facultyName}-${item.specialityName}-${item.specialityModeName}-${item.specialityTypeName}`;

    if (!aggregatedData.has(key)) {
      aggregatedData.set(key, {
        faculty: item.facultyName,
        speciality: item.specialityName,
        specialityMode: item.specialityModeName,
        specialityType: item.specialityTypeName,
        male: 0,
        female: 0,
      });
    }

    const data = aggregatedData.get(key);
    if (item.sex === "Мъж") {
      data.male += item.studentsCount;
    } else if (item.sex === "Жена") {
      data.female += item.studentsCount;
    }
  });

  return Array.from(aggregatedData.values());
};

const EnrolledStudentsReport = () => {
  const { data: report, error, isLoading } = studentsApi.useGetEnrolledStudentsReportQuery(45);

  const transformedData = useMemo(() => {
    if (report) return transformData(report?.data);
    else return [];
  }, [report]);

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Специалност" rowSpan={3} />
        <Column header="Форма" rowSpan={3} />
        <Column header="Тип" rowSpan={3} />
        <Column header="Пол" colSpan={2} />
      </Row>
      <Row>
        <Column header="Мъже" colSpan={1} />
        <Column header="Жени" colSpan={1} />
      </Row>
    </ColumnGroup>
  );

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {JSON.stringify(error)}</div>;

  return (
    <div>
      <h1 className="mb-4 mt-0 text-4xl font-light">Справка: Записани студенти</h1>
      <DataTable
        value={transformedData}
        rowGroupMode="subheader"
        groupRowsBy="faculty"
        rowGroupHeaderTemplate={(data) => {
          return (
            <tr>
              <td colSpan={9} style={{ fontWeight: "700" }}>
                {data.faculty}
              </td>
            </tr>
          );
        }}
        sortMode="single"
        sortField="faculty"
        sortOrder={1}
        headerColumnGroup={headerGroup}
      >
        <Column field="speciality" header="Специалност" />
        <Column field="specialityMode" header="Форма" />
        <Column field="specialityType" header="Тип" />
        <Column field="male" header="Мъже" />
        <Column field="female" header="Жени" />
      </DataTable>
      {/* <Chart type="bar" data={chartData} options={chartOptions} /> */}
    </div>
  );
};

export default EnrolledStudentsReport;
